import React from 'react';
import SubHeader from '../../layout/components/SubHeader';
import './WebInquiry.css';

function WebInquiry() {
    return (
        <div className="ecx-page web-inquiry-page">
            <SubHeader
                title="Web Inquiry"
                description="Review and respond to website inquiry submissions from patients."
                icon="bi-globe2"
                iconTheme="info"
                containerClass="container-fluid px-4"
            />

            <div className="container-fluid px-4 py-3">
                <div className="ecx-page-card ecx-page-panel">
                    <div className="ecx-page-panel__body">
                        <div className="web-inquiry-empty">
                            <span className="web-inquiry-empty__icon" aria-hidden="true">
                                <i className="bi bi-globe2"></i>
                            </span>
                            <h2 className="web-inquiry-empty__title">No web inquiries yet</h2>
                            <p className="web-inquiry-empty__copy mb-0">
                                Inquiry submissions from your clinic website will appear here.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebInquiry;
